import React from 'react';
import { Modal, Spinner, ModalBody, ModalFooter, Button } from 'reactstrap';

// This component must recieve the openModal which is the variable that makes the modal render.
// This component must recieve the onClosed function which is the function that change the variable openModalErro.
// Both openModalErro variable and onClosed function should be defined in the parent component of ModalErro (see Dashboard component).

const ModalConfirmacao = ({
  openModal,
  title,
  subtitle,
  text,
  onClosed,
  onConfirm,
  onSecondary,
  data,
  childComponent = undefined,
  confirmButtonColor = 'primary',
  confirmButtonText = 'Confirmar',
  secondaryButtonText,
  secondaryButtonColor = 'secondary',
  cancelButtonText = 'Cancelar',
  isLoading,
}) => {
  const showSecondaryButton = Boolean(secondaryButtonText && onSecondary);

  return (
    <Modal isOpen={openModal} toggle={onClosed} centered zIndex={2000}>
      <div className="d-flex justify-content-between align-items-center pt-3 pr-4 pl-4">
        <strong className="text-danger">{title}</strong>
        <strong onClick={onClosed} style={{ cursor: 'pointer' }}>
          <i className="ri-close-line" />
        </strong>
      </div>
      <ModalBody>
        {subtitle && (
          <h5>{subtitle}</h5>
        )}
        <p>{text}</p>
        {childComponent && childComponent}
      </ModalBody>
      <ModalFooter>
        <Button
          disabled={isLoading}
          color={confirmButtonColor}
          onClick={onConfirm}
        >
          {isLoading ? <Spinner /> : confirmButtonText}
        </Button>
        {showSecondaryButton && (
          <Button
            disabled={isLoading}
            color={secondaryButtonColor}
            onClick={onSecondary}
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button disabled={isLoading} onClick={onClosed}>
          {cancelButtonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmacao;
